module.exports = __webpack_public_path__ + "img/avatar5.a19c55f6.png";